import { apiClient } from "../lib/api";

export const availabilityApi = {
  submit: (payload) => apiClient.post("/availability/requests", payload),
  myRequests: (requestType, targetMonth) => apiClient.get("/availability/requests/mine", { params: { request_type: requestType || undefined, target_month: targetMonth || undefined } }),
  amend: (id, payload) => apiClient.patch(`/availability/requests/${id}`, payload),
  cancel: (id) => apiClient.post(`/availability/requests/${id}/cancel`),
  listAll: (targetMonth, requestType, status) => apiClient.get("/availability/requests", { params: { target_month: targetMonth || undefined, request_type: requestType || undefined, status: status || undefined } }),
  startReview: (id) => apiClient.post(`/availability/requests/${id}/start-review`),
  review: (id, decision, decisionNote) => apiClient.post(`/availability/requests/${id}/review`, { decision, decision_note: decisionNote }),
  requestClarification: (id, message) => apiClient.post(`/availability/requests/${id}/request-clarification`, { message }),
};
